import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { setNavigateFunction } from '@src/services/navigation-service';

interface NavigationProviderProps {
  children: React.ReactNode;
}

export const NavigationProvider = ({ children }: NavigationProviderProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);

  return <>{children}</>;
};
